export const checkboxCellWidth = 28;
export const marksCellWidth = 92;